import { vdkHappinessPortalApi } from "./vdk-happiness-portal-api";
import { convertModelToFormData } from "@ui/constants/Helper";
const createUser = (command) => {
    const formData = convertModelToFormData(command);
    return vdkHappinessPortalApi.postForm("/user/create", formData);
};
const updateUser = (command) => {
    const formData = convertModelToFormData(command);
    return vdkHappinessPortalApi.postForm("/user/update", formData);
};
const getAll = (query) => {
    return vdkHappinessPortalApi.get("/user/get-all", { params: query });
};
const getById = (query) => {
    return vdkHappinessPortalApi.get("/user/get-by-id", {
        params: query,
    });
};
const getUsersByDesignation = (designationId) => {
    return vdkHappinessPortalApi.get(`/user/${designationId}/get-users-by-designation`);
};
const updateStatus = (command) => {
    return vdkHappinessPortalApi.post("/user/update-status", command);
};
const updateMultipleStatus = (command) => {
    return vdkHappinessPortalApi.post("/user/update-multiple-status", command);
};
const userApi = {
    createUser,
    updateUser,
    getAll,
    getById,
    getUsersByDesignation,
    updateStatus,
    updateMultipleStatus,
};
export default userApi;
